<template>
  <iframe v-if="mapUrl" :src="mapUrl" scrolling="no" marginheight="0" width="100%" height="100%;" frameborder="0" ref="mapref"> </iframe>
</template>
<script>
import { toMapRegion } from '@/utils/helpers'
// import pym from 'pym.js'
export default {
  data() {
    return {
      // mapBaseUrl: 'http://localhost:8080/',
      mapBaseUrl: 'https://regnskog.stage.kartoteket.as/',
      mapUrl: null
    }
  },
  watch: {
    region(regionStub) {
      this.setRegionData(toMapRegion(regionStub))
    },
    country(country) {
      if (country) {
        this.setRegionData(country)
      } else {
        this.setRegionData(this.region)
      }
    },
    dimension(newDimension) {
      this.setDimensionData(newDimension.toLowerCase())
    }
  },
  computed: {
    dimension() {
      return this.$store.state.dimension
    },
    region() {
      return this.$store.state.region
    },
    country() {
      return this.$store.state.country
    }
  },
  methods: {
    setDimensionData(dimension) {
      const layers = {
        fire: false,
        forestcover: false,
        forestloss: false
      }
      const value = dimension === 'fire' ? { region: [this.country || this.region] } : true
      layers[dimension] = value

      const data = {
        method: 'bG9hZGxheWVy',
        layers: layers
      }

      this.$refs.mapref.contentWindow.postMessage(data, '*')
    },
    setRegionData(iso) {
      const data = {
        method: 'em9vbWxvY2F0aW9u', // the method id sent to the map to ensure it is picked up correctly (hint: its base64 encoded 'zoomLocation')
        iso: iso
      }
      this.$refs.mapref.contentWindow.postMessage(data, '*')

      if (this.dimension === 'fire') {
        this.setDimensionData(this.dimension)
      }
    }
  },
  mounted() {
    const location = this.country || this.region

    const forestCover = `&forestCover=${this.dimension === 'forestCover'}`
    const forestLoss = `&forestLoss=${this.dimension === 'forestLoss'}`
    const fire = this.dimension === 'fire' ? `&fire=%257B%2522region%2522%253A%2522${location}%2522%257D` : ''

    this.mapUrl = `${this.mapBaseUrl}?location=${location}&theme=portal&labels=true${forestCover}${forestLoss}${fire}`
  }
}
</script>
